import StudentCourseDetailsFooter from './StudentCourseDetailsFooter';
import { StudentCourseDetailsFooterProps, StudentCourseDetailsFooterValueProps } from './types';

export type { StudentCourseDetailsFooterProps, StudentCourseDetailsFooterValueProps };
export default StudentCourseDetailsFooter;
